@if (isAuthRoute()) {
  <app-auth></app-auth>
} @else {
  <div class="container">
    <div class="header">
      <app-header [user]="user()" [showNavLinks]="true"></app-header>
    </div>
    <div class="main">
      @if (showMobileParentDataLoading()) {
        <div class="parent-data-loading" aria-live="polite" aria-busy="true">
          {{ 'app.parentLayout.loadingPersonalData' | translate }}<span class="parent-data-loading__dots">
            <span class="parent-data-loading__dot">.</span>
            <span class="parent-data-loading__dot">.</span>
            <span class="parent-data-loading__dot">.</span>
          </span>
        </div>
      }

      @if (showIdentityBanner()) {
        <app-parent-identity-banner
          class="identity-banner-slot"
          [inGrace]="identityBannerInGrace()"
          [graceDays]="identityBannerGraceDays()"
        />
      }

      @if (showFamilyContextBar()) {
        <app-duty-review-banner class="duty-review-banner-slot" />
      }

      @if (showFamilyContextBar()) {
        <app-disclosure-approval-banner class="disclosure-approval-banner-slot" />
      }

      @if (showFamilyContextBar()) {
        <app-parent-family-context-bar
          class="family-context-bar"
          [lockKidScope]="lockKidFamilyScope()"
        />
      }

      @if (isMobile()) {
        <div class="mobile-stack">
          @if (showAiAssistant()) {
            <app-ai-assistant-header></app-ai-assistant-header>
          }
          <div
            class="router-component-wrapper"
            [class.router-component-wrapper-mobile]="isMobile()"
            [class.router-component-wrapper-profile-mobile]="isMobile() && isProfilePage()"
            [class.router-component-wrapper-ai-mobile]="isMobile() && isAiAssistant()"
            [class.router-component-wrapper-course-mobile]="isMobile() && isCourseDetail()"
          >
            <router-outlet></router-outlet>
          </div>
        </div>
      } @else {
        <mat-grid-list cols="12" rowHeight="100%" gutterSize="2rem">
          @if (showAiAssistant() && !contentFullWidth()) {
            <mat-grid-tile [colspan]="leftColSpan()">
              <div class="tile-wrapper">
                <app-parent-ai-assistant [isMobile]="false"></app-parent-ai-assistant>
              </div>
            </mat-grid-tile>
          }
          <mat-grid-tile [colspan]="contentFullWidth() ? 12 : rightColSpan()">
            <div
              class="router-component-wrapper"
              [class.router-component-wrapper--course]="contentFullWidth()"
            >
              <router-outlet></router-outlet>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      }
    </div>
  </div>
}
